import React, { FC } from 'react'

import { sumBy } from 'lodash'

import { IRegistrationByDayInterface } from '../../../../../../models/registrations-by-day/registrationByDay.interface'

interface DefaultScoringTotalProps {
  row: IRegistrationByDayInterface
}
export const DefaultScoringTotal: FC<DefaultScoringTotalProps> = ({ row }) => {
  let max = 0
  if (row.score?.judges) {
    max = sumBy(row.score.judges[0]?.sections, (section) => section.max)
  }

  return (
    <>
      <span className="font-semibold"> {row.score?.totalPoints}</span>
      {row.score?.sheet?.name &&
        row.score?.sheet?.name !== 'Default' &&
        row.score?.sheet?.name !== 'Equitation' &&
        row.score?.sheet?.name !== 'Hunters' && (
          <>
            {' '}
            <span>•</span>{' '}
            <span>
              {Number(row.score?.totalPoints) > 0 && max > 0
                ? ((Number(row.score?.totalPoints) / Number(max)) * 100).toFixed(2)
                : 0}
              %
            </span>
          </>
        )}
      {row.score?.scoreStatus && (
        <>
          {' '}
          <span>•</span> {row.score.scoreStatus}
        </>
      )}
    </>
  )
}
